/**
 * DecisionCockpit — Right analysis panel switched by Land | Deal | Execution.
 */
import { LandTab } from './cockpit/LandTab';
import { DealQualityTab } from './cockpit/DealQualityTab';
import { ExecutionPanel } from './cockpit/ExecutionPanel';

export function DecisionCockpit({
  inputs, onInputChange, outputs, outputsChf, fx, decision, qualityGrade,
  combinedVerdict = null,
  assumptions, notes, cadastreData, onCadastreData,
  marketData, onMarketData, visible = true,
  readOnly = false,
  analysisTab = 'land',
  className = '',
}) {
  if (!visible) return null;

  return (
    <aside
      className={`order-first lg:order-last w-full lg:w-[440px] xl:w-[460px] bg-white border-b lg:border-b-0 lg:border-t-0 lg:border-l border-black/10 flex flex-col lg:overflow-hidden shrink-0 ${className}`}
      data-testid="decision-cockpit"
      data-readonly={readOnly ? 'true' : undefined}
      data-analysis-tab={analysisTab}
    >
      {analysisTab === 'land' && (
        <LandTab
          visible
          inputs={inputs}
          onInputChange={onInputChange}
          cadastreData={cadastreData}
          onCadastreData={onCadastreData}
          marketData={marketData}
          onMarketData={onMarketData}
          assumptions={assumptions}
          decision={decision}
          fx={fx}
          readOnly={readOnly}
        />
      )}

      {analysisTab === 'deal' && (
        <div className="lg:flex-1 lg:overflow-y-auto lg:min-h-0">
          <DealQualityTab
            outputs={outputs}
            outputsChf={outputsChf}
            decision={decision}
            qualityGrade={qualityGrade}
            combinedVerdict={combinedVerdict}
          />
        </div>
      )}

      {analysisTab === 'execution' && (
        <ExecutionPanel decision={decision} notes={notes} />
      )}
    </aside>
  );
}
